/* Meno Aliv PDP (ADR 0001) — só comportamento de interface. Preço, parcelas e
   variantes vêm renderizados do servidor; aqui só se alterna o que está visível.
   A compra em si é o [data-add-to-cart] do mna.js. */
(function () {
  "use strict";

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------ kits */
  // Mesmo índice nos dois lugares: painel da buy box e painel da barra fixa.
  function showKit(pdp, idx) {
    $all("[data-kit-panel]", pdp).forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-kit-panel") !== idx;
    });
  }

  function setupKits(pdp) {
    pdp.addEventListener("change", function (e) {
      if (e.target.matches("[data-kit-input]")) showKit(pdp, e.target.value);
    });
  }

  /* ---------------------------------------------------------- galeria */
  function setActiveThumb(gallery, idx) {
    $all("[data-pdp-thumb]", gallery).forEach(function (t, i) {
      t.classList.toggle("is-active", i === idx);
      if (i === idx) t.setAttribute("aria-current", "true");
      else t.removeAttribute("aria-current");
    });
  }

  function setupGallery(gallery) {
    var track = gallery.querySelector("[data-pdp-track]");
    var slides = $all("[data-pdp-slide]", gallery);
    if (!track || slides.length < 2) return;
    gallery.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-pdp-thumb]");
      if (!thumb) return;
      var idx = parseInt(thumb.getAttribute("data-pdp-thumb"), 10);
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: "smooth" });
      setActiveThumb(gallery, idx);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) setActiveThumb(gallery, slides.indexOf(en.target));
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function (s) { io.observe(s); });
  }

  /* ------------------------------------------------------- barra fixa */
  // Mostra quando o CTA da buy box já passou para cima da tela. Abaixo dele
  // (ainda não chegou) não mostra: o CTA principal vem logo ali.
  function toggleSticky(sticky, show) {
    sticky.classList.toggle("is-visible", show);
    if (show) sticky.removeAttribute("inert");
    else sticky.setAttribute("inert", "");
    document.body.classList.toggle("has-pdp-sticky", show);
  }

  function setupSticky(pdp) {
    var sticky = pdp.querySelector("[data-pdp-sticky]");
    var cta = pdp.querySelector("[data-pdp-cta]");
    if (!sticky || !cta) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      toggleSticky(sticky, !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(cta);
  }

  /* ------------------------------------------------------------- boot */
  function boot(root) {
    $all("[data-mna-pdp]", root).forEach(function (pdp) {
      if (pdp.hasAttribute("data-pdp-ready")) return;
      pdp.setAttribute("data-pdp-ready", "");
      setupKits(pdp);
      setupSticky(pdp);
      $all("[data-pdp-gallery]", pdp).forEach(setupGallery);
    });
  }

  if (document.readyState !== "loading") boot(document);
  else document.addEventListener("DOMContentLoaded", function () { boot(document); });

  // Theme Editor: seção recarregada volta sem listeners.
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
